

const awards = [
  {
    id: 1,
    name: "AWS Certified Cloud Practitioner",
    type: "badge", 
    image: "https://images.credly.com/size/680x680/images/00634f82-b07f-4bbd-a6bb-53de397fc3a6/image.png",
    link: "https://www.credly.com/badges/51f1f8c6-687c-4fcc-8ed9-3bbcb8b2f3a5/public_url",
  },
  {
    id: 2,
    name: "Engineering Leadership Development Program",
    type: "badge", 
    image: "https://images.credly.com/size/680x680/images/fe348bee-9505-45b6-8823-a70568afe0ea/image.png",
    link: "https://www.credly.com/badges/66f715b7-27e0-42fc-ae41-38fe2b6b8ce9/public_url",
  },
  {
    id: 3,
    name: "National Honorable Mention AiC",
    type: "badge", 
    image: "https://upload.wikimedia.org/wikipedia/commons/0/02/NCWITSquareLogo.png",
    link: "https://www.aspirations.org/news/2019-award-for-aic-national-award-recipients",
  },
  {
    id: 4,
    name: "Best Use of External Data at ASA DataFest",
    type: "badge", 
    image: "https://sites.psu.edu/datafest/files/2020/02/reg-bnnr-logo-3.png",
    link: "https://datafest.psu.edu/previous/_2023/",
  },
  
  
];

export default awards;
